import src from "IMAGE";
export default { src, width: 1800, height: 150, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AMuprWHYv8FJ173AS9i+wUqvpKVcnp6eXp2dnV6bm5tgT34TVtepWVcAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
